import Api from '../functions/api';

const alterarPerfil = (profile) => {
  return Api.get(`/Authentication/AlterarPerfil/${profile}`);
};

const autenticar = (body) => {
  return Api.post('/Authentication/Login', body);
};

const obterDominios = () => {
  return Api.get('/Authentication/Dominios');
};

const renovarSessao = () => {
  return Api.get('/Authentication/Renew');
};

const autenticarTaH = (body) => {
  return Api.post('/Authentication/LoginGSI', body);
};

export const LoginStore = {
  alterarPerfil,
  autenticar,
  autenticarTaH,
  obterDominios,
  renovarSessao,
};
